import { UtmParams } from '@alice-financial/alice-sdk'

// UTM params passed in from a querystring will _never_ be `null`, but they will otherwise align with the `UtmParams` input object
export type UtmSearchParams = Partial<Record<keyof UtmParams, string>>

export type FeatureFlagValue = string | number | null | boolean | undefined
export type IndentifiableUser = { id?: string } /**

 * Define string-based enum that can be used as first argument to `analytics.track` calls - ideally
 * we should avoid using arbitrary string args
 */
export enum TrackingEvent {
  EnrollmentStart = 'enrollment_start',
  AliceCardRequested = 'AliceCardRequested',
  ProfileTypeChanged = 'ProfileTypeChanged',
}
